import { useState, useEffect } from 'react';
import { getWindowWidth, getWindowHeight } from '../modules/utils';

function getWindowSize() {
  return {
    height: getWindowHeight(),
    width: getWindowWidth(),
  };
}

// since these run on the client, we shouldn't set any defaults
// until the first render pass has happened, as React will ignore it
// https://github.com/facebook/react/issues/11128

function useWindowSize() {
  let [windowSize, setWindowSize] = useState({
    height: undefined,
    width: undefined,
  });

  function handleResize() {
    setWindowSize(getWindowSize());
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    setTimeout(() => {
      handleResize();
    }, 0);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
}

export default useWindowSize;
